import { format, isValid, parse } from 'date-fns'
// Convert a string to a date using the given format
export const stringToDate = (
  value: string | null | undefined,
  stringFormat: string,
): Date | null | undefined => {
  if (!value) return undefined
  const date = parse(value, stringFormat, new Date())
  return isValid(date) ? date : undefined
}
// Convert a date to a string using the given format
export const dateToString = (
  date: Date | null | undefined,
  stringFormat: string,
): string | null | undefined => (date ? format(date, stringFormat) : undefined)
